<template>
  <div>
    <h1 class="h4 mb-4">Create Evaluation</h1>
    <LoadingIndicator 
      v-if="waiters.loading"
      topic="Question"
    />
    <div v-if="dataLoaded && !waiters.loading">
      <form id="questionForm" @submit.prevent="handleSubmit">
        <div 
          v-for="question in goalQuestions"
          :key="question.questionId"
          class="mb-4"
        >
          <h3 class="h5">{{ question.goal }} Question</h3>
          <b-card>
            <b-form-group
              label="Question Text"
            >
              <b-form-textarea
                v-model.trim="question.text"
                :state="errors.length == 0 ? null : isValidQuestion(question)"
                placeholder="Enter your question here..."
                maxLength="400"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
              <p
              >{{question.text.length}} / 400 Max Characters </p>
            </b-form-group>
            <div v-if="question.type === 'Multiple Choice (Graded)'">
              <b-row
                class="text-left mb-2"
                v-for="answer in question.answerOptions"
                v-bind:key="answer.answerIndex">
                <b-col cols="1" class="text-center font-weight-bold">{{answer.answerIndex}}</b-col>
                <b-col cols="6">
                  <b-form-input
                    v-model.trim="answer.answerText"
                    size="sm"
                    maxlength="250"
                    :state="errors.length == 0 ? null : isValidAnswer(answer)"
                    :placeholder="'Enter an answer for ' +answer.answerIndex">
                    {{answer.answerText}}
                  </b-form-input>
                </b-col>
                <b-col cols="2"></b-col>
              </b-row>
            </div>
          </b-card>
        </div>
        <div 
          v-if="otherQuestions.length > 0"
        >
          <hr />
          <h3 class="h5">Additional Questions</h3>
          <b-card
            v-for="question in otherQuestions"
            :key="question.questionId"
            class="mb-4 position-relative"
          >
            <b-button
              variant="link"
              type="button"
              class="position-absolute top-0 right-0 pr-1"
              @click="removeQuestion(question.questionId)"
            >
              <b-icon icon="x" font-scale="1.5"></b-icon><span class="sr-only"> Remove question</span>
            </b-button>
            <b-form-group
              label="Question Text"
            >
              <b-form-textarea
                v-model.trim="question.text"
                :state="errors.length == 0 ? null : isValidQuestion(question)"
                placeholder="Enter your question here..."
                maxLength="400"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
              <p
              >{{question.text.length}} / 400 Max Characters </p>
            </b-form-group>
            <b-form-group
              label="Question Type"
              label-for="questionType">
                <b-form-select
                  v-model="question.type"
                  @change="(resetOptionsIfShortAnswer(question))"
                >
                  <b-form-select-option value="Multiple Choice (Graded)">Multiple Choice (Graded)</b-form-select-option>
                  <b-form-select-option value="Short Answer">Short Answer</b-form-select-option>
                </b-form-select>
            </b-form-group>
            <div v-if="question.type === 'Multiple Choice (Graded)'">
              <b-row
                class="text-left mb-2"
                v-for="answer in question.answerOptions"
                v-bind:key="answer.answerIndex">
                <b-col cols="1" class="text-center font-weight-bold">{{answer.answerIndex}}</b-col>
                <b-col cols="6">
                  <b-form-input
                    v-model.trim="answer.answerText"
                    size="sm"
                    maxlength="250"
                    :state="errors.length == 0 ? null : isValidAnswer(answer)"
                    :placeholder="'Enter an answer for ' +answer.answerIndex">
                    {{answer.answerText}}
                  </b-form-input>
                </b-col>
                <b-col cols="2"></b-col>
              </b-row>
            </div>
          </b-card>
        </div>
        <div class="text-center">
          <b-button
            type="button"
            variant="primary"
            @click="addQuestion"
          >
            <b-icon icon="plus" font-scale="1.5"></b-icon>
            Add a Question
          </b-button>
        </div>
        
        
        <b-row class="mt-3 justify-content-center">
          <b-button
            type="submit"
            variant="primary"
            :disabled="waiters.sending"
          >
            <div v-if="!waiters.sending">
              Create Evaluation
            </div>
            <div v-if="waiters.sending">
              <b-spinner small v-if="waiters.sending" label="Spinning"></b-spinner>
            </div>
          </b-button>
          <!-- <b-button @click="navigateBackToQuestionList">Cancel</b-button> -->
        </b-row>
      </form>
    </div>
    <BaseMessageBlock :messages="errors"></BaseMessageBlock>
    <ProjectWizardSurveyCreated
      v-if="isSurveySent"
      :projectId="projectId"
      @submit="showOverviewTab"
      @cancel="refreshSurveyTabAfterCreate"
    />
  </div>
</template>
<script>
import axios from "axios";
import ProjectWizardSurveyCreated from "@/components/ProjectWizardSurveyCreated.vue";

export default {
  components: {
    ProjectWizardSurveyCreated
  },
  props: {
    projectId: { type: String, required: true },
    surveyId: { type: String, required: true }
  },
  data() {
    return {
      errors: [],
      dataLoaded: true,
      // mode: null,
      // newQuestion: "",
      // questionLength: 0,
      waiters: {
        loading: false,
        sending: false
      },
      // question: {
      //   questionId: "",
      //   text: "",
      //   sortOrder: 0,
      //   type: "Multiple Choice (Graded)",
      //   required: true,
      //   answerOptions: []
      // },
      goals: [],
      goalQuestions: [],
      otherQuestions: [],
      // projectId: this.$route.params.id,
      // projectId: null,
      // answerOptions: [],
      questionMaxlength: 450,
      questionMinlength: 5,
      answerMinlength: 2,
      questionTemplates: [],
      isSurveySent: false
    };
  },
  computed: {
    // isMultiQuestion() {
    //   return this.question.type === "Multiple Choice (Graded)";
    // }
    allQuestions() {
      return this.goalQuestions.map(({goal, ...rest}) => rest).concat(this.otherQuestions);
    },
  },
  watch: {
    // isMultiQuestion(isMulti) {
    //   this.resetAnswerOptions();
    // }
  },
  mounted() {
    if (!this.isSystemAdmin) {
      this.defaultRedirect();
    }
    // if (this.$route.params.id) {
    //   this.setupEditQuestion();
    // } else {
    //   this.setupNewQuestion();
    // }
    // this.projectId = this.$route.params.id;
    // this.mode = "Create";
    this.loadGoals();
    this.loadQuestionTemplates();
    // this.answerOptions = this.returnDefaultAnswerOptions();
  },
  methods: {
    loadGoals() {
      this.waiters.loading = true;
      axios
        .get(
          `${this.$api_url}/goals/${this.projectId}`,
          this.getReqConfig()
        )
        .then(response => {
          this.goals = response.data;
          if ( this.questionTemplates.length > 0 
                && this.goalQuestions.length === 0 ) {
            this.setupQuestions();
          }
        })
        .catch(err => {
          this.errors.push(err);
          // this.dataLoaded = false;
        })
        .finally(() => {
          this.waiters.loading = false;
        });
    },
    loadQuestionTemplates() {
      this.waiters.loading = true;
      axios
        .get(`${this.$api_url}/question-templates`, this.getReqConfig())
        .then(response => {
          this.questionTemplates = response.data;
          if ( this.goals.length > 0 
                && this.goalQuestions.length === 0 ) {
            this.setupQuestions();
          }
          // question.text
        })
        .catch(err => {
          this.errors.push(err);
        })
        .finally(() => {
          this.waiters.loading = false;
        });
    },
    setupQuestions() {
      this.goals.forEach(goal => {

        const matchingTemplates = this.questionTemplates.filter(q => 
              q.text.trim() === goal.name.trim());
        
        let goalAnswerOptions = 
          matchingTemplates.length > 0 && matchingTemplates[0].type === 'Multiple Choice (Graded)' ?
          matchingTemplates[0].answerOptions :
          this.returnDefaultAnswerOptions();

        goalAnswerOptions.sort((a,b) => 
          this.$helpers.compareAlpha(a.answerIndex, b.answerIndex));

        const newGoalQuestion = {
          questionId: this.$helpers.generateUUID(),
          surveyId: this.surveyId,
          goal: goal.name,
          text: goal.name,
          sortOrder: 0,
          type: "Multiple Choice (Graded)",
          required: true,
          commentTitle: '',
          answerOptions: goalAnswerOptions
        };

        newGoalQuestion.answerOptions.forEach(ao => {
          ao.answerOptionId = this.$helpers.generateUUID();
          ao.questionId = newGoalQuestion.questionId;
        });

        this.goalQuestions.push(newGoalQuestion);
      });
    },
    resetOptionsIfShortAnswer(question) {
      if (question.type === "Short Answer") {
        this.resetAnswerOptions(question);
      }
    },
    resetAnswerOptions(question) {
      question.answerOptions.forEach(option => {
        option.answerText = "";
        option.commentRequired = false;
      });
    },
    returnDefaultQuestion() {
      return {
        questionId: this.$helpers.generateUUID(),
        surveyId: this.surveyId,
        text: '',
        sortOrder: 0,
        type: "Multiple Choice (Graded)",
        required: true,
        commentTitle: '',
        answerOptions: this.returnDefaultAnswerOptions()
      };
    },
    returnDefaultAnswerOptions() {
      return [
        {
          answerIndex: "A",
          answerText: "",
          answerScore: 4,
          commentRequired: false
        },
        {
          answerIndex: "B",
          answerText: "",
          answerScore: 3,
          commentRequired: false
        },
        {
          answerIndex: "C",
          answerText: "",
          answerScore: 2,
          commentRequired: true
        },
        {
          answerIndex: "D",
          answerText: "",
          answerScore: 1,
          commentRequired: true
        },
        {
          answerIndex: "F",
          answerText: "",
          answerScore: 0,
          commentRequired: true
        },
        {
          answerIndex: "NA",
          answerText: "",
          answerScore: -1,
          commentRequired: false
        }
      ];
    },
    validateForm() {
      // let formIsValid = true;
      // if (!this.validateQuestion()) {
      //   formIsValid = false;
      //   this.errors.push({
      //     message: "Please enter a question 5 or more characters in length."
      //   });
      // }
      this.allQuestions.forEach(question => {
        this.validateQuestion(question);

        if (question.type === 'Multiple Choice (Graded)') {
          question.answerOptions.forEach(answer => {
            this.validateAnswer(answer, question);
          });
        }
      });
      // if (this.isMultiQuestion) {
      //   for (let a of this.question.answerOptions) {
      //     if (!this.validateAnswer(a.answerText)) {
      //       formIsValid = false;
      //       this.errors.push({
      //         message: `Answer '${a.answerIndex}' must be 2 or more characters in length.`
      //       });
      //     }
      //   }
      // }
      // return formIsValid;
    },
    validateQuestion(question) {
      // const initialErrorsCount = this.errors.length;

      if(!this.isValidQuestionMinlength(question)) {
        this.errors.push({
          message: `Question must be at least ${this.questionMinlength} characters long.`
        });
      }
      if(!this.isValidQuestionMaxlength(question)) {
        this.errors.push({
          message: `Question must be shorter than ${this.questionMinlength} characters long.`
        });
      }

      // return this.errors.length === initialErrorsCount;
    },
    isValidQuestion(question) {
      return this.isValidQuestionMinlength(question) && this.isValidQuestionMaxlength(question);
    },
    isValidQuestionMinlength(question) {
      return question.text.length >= this.questionMinlength;
    },
    isValidQuestionMaxlength(question) {
      return question.text.length <= this.questionMaxlength;
    },
    validateAnswer(answer, question) {
      if (!this.isValidAnswer(answer)) {
        this.errors.push({
          message: `Answer '${answer.answerIndex}' for Question '${question.text}' must be 2 or more characters in length.`
        });
      }
    },
    isValidAnswer(answer) {
      return answer.answerText.length >= this.answerMinlength;
    },
    // navigateBackToQuestionList() {
    //   this.$router.push({
    //     name: "Evaluation Templates"
    //   });
    // },
    addQuestionsOrder() {
      let startIndex = 0;
      this.allQuestions.forEach(q => {
        q.sortOrder = startIndex++;
      });
    },
    handleSubmit() {
      this.errors = [];
      this.validateForm();
      
      if (this.errors.length === 0) {
        // if (!this.question.questionId) {
        //   this.question.questionId = this.$helpers.generateUUID();
        // }
        this.addQuestionsOrder();

        this.allQuestions.forEach(question => {

          if (question.type === 'Multiple Choice (Graded)') {
            question.answerOptions.forEach(ao => {
              if (!ao.answerOptionId) {
                ao.answerOptionId = this.$helpers.generateUUID();
              }
            });
          }

          this.waiters.sending = true;
          const url = `${this.$api_url}/question/add`;
          axios
            .put(`${this.$api_url}/question/add`, question, this.getReqConfig())
            .then(() => {
              question.isQuestionCreated = true;
              const createdQuestions = this.allQuestions.filter(q => q.isQuestionCreated);
              if (this.allQuestions.length === createdQuestions.length) {
                // this.$refs.ProjectWizardSurveyCreated.show();
                this.isSurveySent = true;
              }
            })
            .catch(err => {
              if (err.response && err.response.data) {
                this.errors.push(...err.response.data.map(e => ({message: e})));
              } else {
                this.errors.push(err);
              }
              
            })
            .finally(() => {
              this.waiters.sending = false;
            });
        });
        
      } else {
        // let message =
        //   "Some entries are invalid. Please correct these and resubmit.";
        // this.errors.push({ message });
      }
    },
    // sendEvaluation(respondent) {
    //   respondent.isLoading = true;

    //   axios
    //     .post(`${this.$api_url}/notification/send`,
    //       {
    //         userId: respondent.userId,
    //         projectName: this.projectName,
    //         responseId: respondent.responseData.responseId
    //       },
    //       this.getReqConfig()
    //     )
    //     .then(() => {
    //       respondent.responseData.lastNotifiedDate = "Today";
    //     })
    //     .catch(err => {
    //       this.errors.push(err);
    //     })
    //     .finally(() =>{
    //       respondent.isLoading = false;
    //       respondent.sent = true;
    //     });
    // },
    addQuestion() {
      const newQuestion = this.returnDefaultQuestion();
      this.otherQuestions.push(newQuestion);
    },
    removeQuestion(id) {
      this.otherQuestions = this.otherQuestions.filter(q => q.questionId !== id);
    },
    showOverviewTab() {
      this.$emit('showOverviewTab');
    },
    refreshSurveyTabAfterCreate() {
      this.$emit('refreshSurveyTabAfterCreate', this.allQuestions);
    }
  }
};
</script>
